import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AvField, AvForm, AvInput } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Label } from 'reactstrap';

import { createPlcSafetyTrigger, getPlcSafetyEvents } from '../../store/actions';

class CreatePlcSafetyTriggerForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      action: '0',
      eventId: '',
      skipIfBarrierWorking: false,
      popup: false,
      pop_msg: null,
      pop_err: null,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getPlcSafetyEvents(this.state.user);
  }

  componentDidUpdate(prevProps) {
    const { messagePlcSafetyTrigger, createPlcSafetyTriggerError, loadingCreatePlcSafetyTrigger } = this.props;
    if (loadingCreatePlcSafetyTrigger === false && prevProps.loadingCreatePlcSafetyTrigger === true) {
      if (messagePlcSafetyTrigger) {
        this.setState({ popup: true, pop_msg: 'Trigger creado correctamente' });
      } else if (createPlcSafetyTriggerError) {
        this.setState({
          popup: true,
          pop_err: createPlcSafetyTriggerError.message || 'No se ha podido crear el trigger',
        });
      }
    }
    if ((this.props.events || []).length > 0 && !this.state.eventId) {
      this.setState({ eventId: String(this.props.events[0].id) });
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
    if (this.state.pop_msg) this.props.history.push('/plcSafetyTriggers');
  }

  handleValidSubmit(event, values) {
    const user = this.state.user;
    values.action = this.state.action;
    values.event_id = Number(this.state.eventId);
    values.skip_if_barrier_working = this.state.skipIfBarrierWorking;
    values.token = user.token;
    this.props.createPlcSafetyTrigger(values);
  }

  render() {
    const events = this.props.events || [];
    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t('Crear trigger PLC Safety')}</CardTitle>
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="triggerName">{this.props.t('Nombre')}</Label>
                  <AvField
                    name="name"
                    placeholder={this.props.t('Nombre')}
                    type="text"
                    errorMessage="Introduzca un nombre válido"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="triggerName"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="triggerTelegramType">{this.props.t('Identificador de telegrama')}</Label>
                  <AvField
                    name="telegram_type"
                    placeholder="SA, ES, PA, SC..."
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="triggerTelegramType"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="triggerAction">{this.props.t('Acción del telegrama')}</Label>
                  <AvInput
                    value={this.state.action}
                    name="action"
                    type="select"
                    className="form-control"
                    id="triggerAction"
                    onChange={(e) => this.setState({ action: e.target.value })}
                  >
                    <option value="0">{this.props.t('0 (activación)')}</option>
                    <option value="1">{this.props.t('1 (rearme)')}</option>
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="triggerElementPattern">{this.props.t('Patrón de elemento (SQL LIKE)')}</Label>
                  <AvField
                    name="element_pattern"
                    placeholder="%FRONT%"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="triggerElementPattern"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="triggerEvent">{this.props.t('Evento')}</Label>
                  <AvInput
                    value={this.state.eventId}
                    name="event_id"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="triggerEvent"
                    onChange={(e) => this.setState({ eventId: e.target.value })}
                  >
                    {events.map((ev) => (
                      <option key={ev.id} value={ev.id}>
                        {ev.name}
                      </option>
                    ))}
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup check className="mb-3">
                  <Label check htmlFor="triggerSkipIfBarrierWorking">
                    <Input
                      type="checkbox"
                      id="triggerSkipIfBarrierWorking"
                      checked={this.state.skipIfBarrierWorking}
                      onChange={(e) => this.setState({ skipIfBarrierWorking: e.target.checked })}
                    />{' '}
                    {this.props.t('Omitir si la posición ya está en modo trabajo (barrera deshabilitada)')}
                  </Label>
                  <div className="text-muted" style={{ fontSize: '0.85em' }}>
                    {this.props.t(
                      'Si está marcado, este trigger no creará ninguna causa ni parará nada cuando la posición afectada ya tenga la barrera deshabilitada por trabajo (BA1 enviado) — se confirma al PLC en silencio.',
                    )}
                  </div>
                </FormGroup>
              </Col>
              <Button color="secondary" type="submit">
                {this.props.t('Crear trigger')}
              </Button>
            </AvForm>
            {this.state.popup ? (
              <SweetAlert
                type={this.state.pop_msg ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.pop_msg ? 'success' : 'danger'}
                title={this.state.pop_msg ? this.state.pop_msg : this.state.pop_err}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateprops = (state) => {
  const { createPlcSafetyTriggerError, messagePlcSafetyTrigger, loadingCreatePlcSafetyTrigger } =
    state.createPlcSafetyTrigger;
  const { events } = state.getPlcSafetyEvents;
  return { createPlcSafetyTriggerError, messagePlcSafetyTrigger, loadingCreatePlcSafetyTrigger, events };
};

export default withRouter(
  connect(mapStateprops, { createPlcSafetyTrigger, getPlcSafetyEvents })(
    withNamespaces()(CreatePlcSafetyTriggerForm),
  ),
);
